import { utility_controller } from '../utility/utility_controller'

/**
 * Rewrites TinyMCE-inserted `<a href="#laynextproject">` / `<a class="laynextproject">`
 * (and prev counterparts) on lay_deck slides to point at the next/prev deck slide.
 * Mirror of prevnext_news_controller — Lay's existing AJAX nav (bind_anchors.js)
 * picks up the data-* attrs we set and pushes the new slide page.
 *
 * The bottom counter widget (deck_controller) handles ←/→ keyboard nav; this
 * one is purely about content-author-inserted prev/next links.
 */

var prevnext_deck_controller = {
	i: function () {
		i()
	},
}

var i = function () {
	if (typeof layData.deckMeta === 'undefined') return
	setStateMap()
	stateMap.deckMeta = JSON.parse(layData.deckMeta)

	window.laytheme.on('newpageshown', function () {
		setStateMap()
		updateDeckPrevNextLinksAddedWithTinyMCE()
	})
}

export default prevnext_deck_controller

var stateMap = {
	id: null,
	type: null,
	deckMeta: [],
}

var setStateMap = function () {
	stateMap.id = jQuery('body').attr('data-id')
	stateMap.type = jQuery('body').attr('data-type')
}

var getDeckIndex = function (nextprev) {
	var ix, i
	var currentId = stateMap.id
	var length = stateMap.deckMeta.length

	for (i = 0; i < length; i++) {
		if (currentId == stateMap.deckMeta[i]['id']) {
			ix = i
			break
		}
	}

	if (nextprev == 'next') {
		ix++
		if (ix == length) {
			ix = 0
		}
	} else if (nextprev == 'prev') {
		ix--
		if (ix < 0) {
			ix = length - 1
		}
	}
	return ix
}

var getDeckLinkObj = function (nextprev) {
	var ix = getDeckIndex(nextprev)
	if (jQuery.isNumeric(ix)) {
		return {
			title: stateMap.deckMeta[ix]['title'],
			url: stateMap.deckMeta[ix]['url'],
			id: stateMap.deckMeta[ix]['id'],
		}
	}
}

var updateDeckPrevNextLinksAddedWithTinyMCE = function ($parent) {
	if ($parent == undefined) {
		$parent = jQuery('body')
	}
	if (jQuery('body').attr('data-type') == 'lay_deck') {
		$parent.find('a[href="#laynextproject"], a.laynextproject').each(function () {
			var obj = getDeckLinkObj('next')
			if (typeof obj != 'undefined') {
				jQuery(this).attr({
					'data-type': 'lay_deck',
					href: obj.url,
					'data-id': obj.id,
					'data-title': obj.title,
				})
				var text = jQuery(this).attr('data-original-text') == undefined ? jQuery(this).text() : jQuery(this).attr('data-original-text')
				if (text.includes('$nextprojecttitle$')) {
					if (jQuery(this).attr('data-original-text') == undefined) {
						jQuery(this).attr('data-original-text', text)
					}
					var newText = text.replace('$nextprojecttitle$', obj.title)
					jQuery(this).text(newText)
				}
			}
		})

		$parent.find('a[href="#layprevproject"], a.layprevproject').each(function () {
			var obj = getDeckLinkObj('prev')
			if (typeof obj != 'undefined') {
				jQuery(this).attr({
					'data-type': 'lay_deck',
					href: obj.url,
					'data-id': obj.id,
					'data-title': obj.title,
				})
				var text = jQuery(this).attr('data-original-text') == undefined ? jQuery(this).text() : jQuery(this).attr('data-original-text')
				if (text.includes('$previousprojecttitle$')) {
					if (jQuery(this).attr('data-original-text') == undefined) {
						jQuery(this).attr('data-original-text', text)
					}
					var newText = text.replace('$previousprojecttitle$', obj.title)
					jQuery(this).text(newText)
				}
			}
		})
	}
}

window.updateDeckPrevNextLinksAddedWithTinyMCE = updateDeckPrevNextLinksAddedWithTinyMCE

export { updateDeckPrevNextLinksAddedWithTinyMCE }
